import useCollectedUserData from './useCollectedUserData';

const useEligibleActions = () => {
  const { eligibleAnnouncements } = useCollectedUserData();
  return eligibleAnnouncements;
};

export default useEligibleActions;
